export default "__VITE_ASSET__Bh2JytLV__"